import * as React from 'react';
import { Create, Edit, Identifier } from 'react-admin';
import Form from './components/Form';
import FormHeader from '../../components/FormHeader';

interface SourceVariableModelProps {
    isEdit: boolean;
    onCancel: () => void;
    updateModel: () => void;
    id?: Identifier;
}

const SourceVariableModel: React.FC<SourceVariableModelProps> = ({ isEdit, onCancel, updateModel, ...props }) => {
    return (

        isEdit && (
            <Edit {...props} title=" ">
                <>
                    <FormHeader onCancel={onCancel} isEdit={isEdit} />
                    <Form onCancel={onCancel} updateModel={updateModel} isEdit={isEdit} />
                </>
            </Edit>
        ) ||
        (
            <Create title=" ">
                <>

                    <FormHeader onCancel={onCancel} isEdit={isEdit} />
                    <Form onCancel={onCancel} updateModel={updateModel} isEdit={isEdit} />
                </>
            </Create>
        )

    );
};
export default SourceVariableModel;
